import { useI18n } from '../i18n';

export function OfflineShell() {
  const { locale } = useI18n();
  return <section className="pwa-offline-shell" role="status" aria-live="polite">
    <div className="pwa-offline-mark" aria-hidden="true">ML</div>
    <p className="eyebrow">Menu Lab · Offline</p>
    <h1>{locale === 'zh-CN' ? '当前离线' : 'You are offline'}</h1>
    <p>{locale === 'zh-CN'
      ? '应用外壳已保存在这台设备上，所以 Menu Lab 仍能启动。为避免把过期业务数据当成真实数据，Service Worker 不会缓存配方、菜品、菜单或账号 API。网络恢复后会自动回到正常界面。'
      : 'The app shell is stored on this device, so Menu Lab can still launch. To avoid presenting stale business data as current, the Service Worker never caches recipe, dish, menu, or account APIs. The normal interface returns automatically when connectivity is restored.'}</p>
    <small>{locale === 'zh-CN' ? '离线业务数据与草稿保存将在本地数据层启用后提供。' : 'Offline business data and durable drafts will be provided by the local data layer.'}</small>
  </section>;
}
